/**
 * Injeta os tokens como CSS custom properties na raiz do documento.
 *
 * Gerados por `@nv/tokens`, com os MESMOS nomes de variável do protótipo —
 * é o que permite copiar um valor de lá e ele continuar significando o mesmo.
 */
import { tokensStylesheet } from '@nv/tokens';

export function installTokens(): void {
  const style = document.createElement('style');
  style.dataset.nv = 'tokens';
  style.textContent = tokensStylesheet();
  document.head.prepend(style);
}
